// src/systems/inputSystem.ts — Input teclado + táctil (Fase 2)
export type InputState = {
  up: boolean; down: boolean; left: boolean; right: boolean;
  interact: boolean; // espacio / E / enter
  map: boolean; // M
  escape: boolean; // Esc
  interactPressed: boolean; // edge
  mapPressed: boolean;
};

export class InputSystem {
  state: InputState = { up:false, down:false, left:false, right:false, interact:false, map:false, escape:false, interactPressed:false, mapPressed:false };
  private prevInteract=false; private prevMap=false;
  private keys = new Set<string>();

  attach(): void {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
  }
  detach(): void {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
  }

  private onKeyDown = (e: KeyboardEvent): void => {
    const k = e.key.toLowerCase();
    this.keys.add(k);
    // evitar scroll con flechas/espacio
    if ([' ', 'arrowup','arrowdown','arrowleft','arrowright'].includes(k)) e.preventDefault();
  };
  private onKeyUp = (e: KeyboardEvent): void => {
    this.keys.delete(e.key.toLowerCase());
  };

  update(): void {
    const k = this.keys;
    this.state.up = k.has('w') || k.has('arrowup');
    this.state.down = k.has('s') || k.has('arrowdown');
    this.state.left = k.has('a') || k.has('arrowleft');
    this.state.right = k.has('d') || k.has('arrowright');
    this.state.interact = k.has(' ') || k.has('e') || k.has('enter');
    this.state.map = k.has('m');
    this.state.escape = k.has('escape');
    this.state.interactPressed = this.state.interact && !this.prevInteract;
    this.state.mapPressed = this.state.map && !this.prevMap;
    this.prevInteract = this.state.interact;
    this.prevMap = this.state.map;
  }

  // Para controles táctiles: set directo
  setDir(dir: 'up'|'down'|'left'|'right'|null, active: boolean): void {
    if (!dir) { this.state.up=this.state.down=this.state.left=this.state.right=false; return; }
    this.state[dir] = active;
  }
  pressInteract(): void {
    this.state.interactPressed = true; this.state.interact = true;
  }
}
